<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-18 21:49:57
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="信息"
            :visible="true"
            width="90%"
            :before-close="handleClose">
        <el-button type="primary" @click="exportData()">导出</el-button>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                border
                height="350"
                style="width: 100%;margin-top: 20px">
            <el-table-column
                    prop="code_name"
                    label="标签类型"
                    width="180"
            >
            </el-table-column>
            <el-table-column
                    prop="logistics_code"
                    label="物流码"
                    width="120"
            >
            </el-table-column>
            <el-table-column
                    prop="production_batch"
                    label="生产批次号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="stock_out_sn"
                    label="原出库单号"
                    width="160"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="return_goods_sn"
                    label="退货单号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_sn"
                    label="产品编号"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_name"
                    label="产品名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="brand_name"
                    label="品牌"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_specs"
                    label="规格"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="product_unit"
                    label="单位"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="warehouse_name"
                    label="退往仓库"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="isgift"
                    label="是否赠品"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        {{scope.row.isgift==1?"赠品":"非增品"}}
                    </template>
            </el-table-column>
            <el-table-column
                    prop="production_date"
                    label="生产日期"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="发货日期"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="expiring_date"
                    label="有效期至"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="created_at"
                    label="退货时间"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="real_return_goods_num"
                    label="退货数量"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>

        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "refund-detail-dialog-cust",
        data() {
            return {
                loading:false,
                tableData:[],
                //分页
                pageNo: 1,//页码
                pageSize: 20,//每页现实的条数
                totalSize: 0,//总条数
            }
        },
        props:{
            refundCustData:{
                type:Object,
                default:function(){
                    return;
                }
            }
        },
        methods: {
            getData(){
                this.loading = true;
                this.$get('logistics','/statistics/returngoods.dealers/datas', {
                    lang:'',
                    per_page:this.pageSize,
                    page:this.pageNo,
                    from_type:this.refundCustData.from_type,
                    from_sn:this.refundCustData.from_sn
                }).then(res => {
                    this.loading = false;

                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;

                    console.log(error);
                });

            },
            //导出
            exportData(){
                let url = '',access_tokens = localStorage.getItem('access_tokens');
        

                window.open(this.$Base_Export
                    +'/statistics/returngoods.dealers/datas.export?is_export=1&from_type='+ this.refundCustData.from_type + '&from_sn=' + this.refundCustData.from_sn+'&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.getData();

            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.getData();


            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            this.getData();

        },
    }
</script>

<style lang="scss" scoped>

</style>